import {FieldConfig} from '../../dynamic-field/field.config';

export interface LabelFieldConfig extends FieldConfig<string> {
    isLink?: boolean;
    linkUrl?: string;
    onLabelClick?: () => {};
    attachToField?: { name: string };
}
